import { render, staticRenderFns } from "./MenuGroupCard.vue?vue&type=template&id=016730b8"
import script from "./MenuGroupCard.vue?vue&type=script&lang=ts"
export * from "./MenuGroupCard.vue?vue&type=script&lang=ts"
import style0 from "./MenuGroupCard.vue?vue&type=style&index=0&id=016730b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports